import React from "react";
import {
  Button,
  Typography,
  Chip,
  CardFooter,
  CardHeader,
  CardBody,
} from "@material-tailwind/react";
import { useNavigate } from "react-router-dom";
import Azure from "../../../assets/images/Azure-Logo-PNG.png";
import GCP from "../../../assets/images/GCP-Logo.png";
import AWS from "../../../assets/images/AWS-logo.jpg"

function GetStarted({ selectedProvider, setStep, scope, setScope }) {
  const navigate = useNavigate();

  const buttonStyle = {
    width: "100%",
    padding: "20px",
    marginBottom: "20px",
    border: "1px solid #ccc",
    cursor: "pointer",
    transition: "background-color 0.2s",
    backgroundColor: "#f4f4f4",
    borderRadius: "8px",
    fontSize: "20px",
  };

  const selectedButtonStyle = {
    ...buttonStyle,
    backgroundColor: "lightblue",
    border: "2px solid rgb(30, 144, 255)",
    color: "#fff",
  };

  return (
    <>
      <div className="flex flex-col justify-center max-w-[800px] items-center w-full m-auto">
        <CardHeader
          floated={false}
          shadow={false}
          className=" bg-transparent rounded-none !overflow-visible"
        >
          <div className="flex flex-col justify-center items-center gap-4 mb-2">
            <img
              src={
                selectedProvider === "AWS" ? (
                  AWS
                ) : selectedProvider === "Azure" ? (
                  Azure
                ) : selectedProvider === "GCP" ? (
                  GCP
                ) : (
                  <></>
                )
              }
              alt="Logo"
              // style={logoStyle}
              className="rounded-lg w-20 h-auto"
            />
            <Typography variant="h4" color="blue-gray">
              Get Started
            </Typography>
          </div>
        </CardHeader>

        <CardBody>
          <Typography
            variant="h5"
            color="blue-gray"
            className="mb-10 justify-self-center text-center"
          >
            Scope
          </Typography>
          {selectedProvider === "AWS" ? (
            <>
              <div className="flex justify-center flex-row gap-10 w-full">
                <div
                  style={
                    scope === "Organization"
                      ? { ...selectedButtonStyle }
                      : { ...buttonStyle }
                  }
                  // onClick={() => setScope("Organization")}
                  className="pointer-events-none opacity-60"
                >
                  <div className="relative">
                    <Typography
                      variant="h6"
                      color="blue-gray"
                      className="font-bold"
                    >
                      Organization
                    </Typography>
                    <Typography
                      variant="p"
                      color="blue-gray"
                      className="mt-2 text-xs"
                    >
                      Secure your account including the members accounts
                    </Typography>
                    <Chip
                      value="Recommended"
                      color="green"
                      size="sm"
                      className="!text-xs absolute top-0 right-0 !font-normal text-center"
                    >
                      Recommended
                    </Chip>
                  </div>
                </div>
                <div
                  style={
                    scope === "Account"
                      ? { ...selectedButtonStyle }
                      : { ...buttonStyle }
                  }
                  onClick={() => setScope("Account")}
                >
                  <Typography
                    variant="h6"
                    color="blue-gray"
                    className="font-bold"
                  >
                    Account
                  </Typography>
                  <Typography
                    variant="p"
                    color="blue-gray"
                    className="mt-2 text-xs"
                  >
                    Secure your specific {selectedProvider} account
                  </Typography>
                </div>
              </div>
            </>
          ) : selectedProvider === "Azure" ? (
            <>
              <div className="flex justify-center flex-row gap-10 w-full">
                <div
                  style={
                    scope === "Tenant"
                      ? { ...selectedButtonStyle }
                      : { ...buttonStyle }
                  }
                  // onClick={() => setScope("Tenant")}
                  className="pointer-events-none opacity-60"
                >
                  <div className="relative pointer-events-none">
                    <Typography
                      variant="h6"
                      color="blue-gray"
                      className="font-bold"
                    >
                      Tenant
                    </Typography>
                    <Typography
                      variant="p"
                      color="blue-gray"
                      className="mt-2 text-xs"
                    >
                      Secure all management Groups,Subscriptions and Active
                      Directory
                    </Typography>
                    <Chip
                      value="Recommended"
                      color="green"
                      size="sm"
                      className="!text-xs absolute top-0 right-0 !font-normal text-center"
                    >
                      Recommended
                    </Chip>
                  </div>
                </div>
                <div
                  style={
                    scope === "Subscription"
                      ? { ...selectedButtonStyle }
                      : { ...buttonStyle }
                  }
                  onClick={() => setScope("Subscription")}
                >
                  <Typography
                    variant="h6"
                    color="blue-gray"
                    className="font-bold"
                  >
                    Subscription
                  </Typography>
                  <Typography
                    variant="p"
                    color="blue-gray"
                    className="mt-2 text-xs"
                  >
                    Secure your specific {selectedProvider} account
                  </Typography>
                </div>
              </div>
            </>
          ) : selectedProvider === "GCP" ? (
            <>
              <div className="flex justify-center flex-row gap-10 w-full">
                <div
                  style={
                    scope === "Organization"
                      ? { ...selectedButtonStyle }
                      : { ...buttonStyle }
                  }
                  // onClick={() => setScope("Organization")}
                  className="pointer-events-none opacity-60"
                >
                  <div className="relative pointer-events-none">
                    <Typography
                      variant="h6"
                      color="blue-gray"
                      className="font-bold"
                    >
                      Organization
                    </Typography>
                    <Typography
                      variant="p"
                      color="blue-gray"
                      className="mt-2 text-xs"
                    >
                      Secure your GCP Organization and all associated Projects
                    </Typography>
                    <Chip
                      value="Recommended"
                      color="green"
                      size="sm"
                      className="!text-xs absolute top-0 right-0 !font-normal text-center"
                    >
                      Recommended
                    </Chip>
                  </div>
                </div>
                <div
                  style={
                    scope === "Project"
                      ? { ...selectedButtonStyle }
                      : { ...buttonStyle }
                  }
                  onClick={() => setScope("Project")}
                >
                  <Typography
                    variant="h6"
                    color="blue-gray"
                    className="font-bold"
                  >
                    Project
                  </Typography>
                  <Typography
                    variant="p"
                    color="blue-gray"
                    className="mt-2 text-xs"
                  >
                    Secure your {selectedProvider} Project
                  </Typography>
                </div>
              </div>
            </>
          ) : (
            <div className="flex justify-center items-center h-screen">
              <Typography variant="h2" color="blue-gray">
                Please go back and select something!
              </Typography>
            </div>
          )}
        </CardBody>
      </div>
      <CardFooter>
        <div className="flex justify-end gap-4 items-center">
          <Button
            variant="gradient"
            color="light-blue"
            onClick={() => {
              setStep("");
            }}
          >
            Previous
          </Button>
          <Button
            variant="gradient"
            color="light-blue"
            disabled={scope ? false : true}
            onClick={() => {
              setStep("Configure");
            }}
          >
            Next
          </Button>

          <Button
            variant="text"
            color="red"
            onClick={() => {
              navigate("/inventory/assets");
            }}
          >
            Cancel
          </Button>
        </div>
      </CardFooter>
    </>
  );
}

export default GetStarted;
